import { useActiveSection } from './useActiveSection';
import { useScrollPosition } from './useScrollPosition';
import { NAVIGATION_SECTIONS } from '../constants/navigation';

export function useNavigation() {
  const sectionIds = NAVIGATION_SECTIONS.map(section => section.id);
  const activeSection = useActiveSection({ sectionIds });
  const scrollPosition = useScrollPosition({ throttle: 50 });

  return {
    activeSection,
    scrollPosition,
    sections: NAVIGATION_SECTIONS,
    isScrolled: scrollPosition.y > 100
  };
}